import teamLogo from "../../../assets/teamLogo.jpg";

const AboutHero = () => {
    return (
        <section className="min-h-screen px-6 py-16 bg-[#f9fafb] text-gray-800">
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div>
                    <h1 className="text-4xl font-bold mb-6 border-b-4 border-blue-900 inline-block pb-2">
                        Giới thiệu
                    </h1>

                    <p className="text-lg mb-6">
                        <span className="font-bold">
                            Mỹ Diệp
                        </span>{" "}
                        là chuyên gia bất động sản với hơn 10 năm kinh nghiệm,
                        dẫn dắt các dự án mua bán, cho thuê và đầu tư nhà đất tại Việt Nam.
                    </p>

                    <p className="text-lg mb-6">
                        Với tầm nhìn hiện đại hóa ngành bất động sản bằng công nghệ
                        và dịch vụ tận tâm, Mỹ Diệp đã xây dựng uy tín vững chắc.
                    </p>

                    <p className="text-lg">
                        Sứ mệnh của cô là kết nối khách hàng với những cơ hội
                        bất động sản thực sự, minh bạch và bền vững.
                    </p>
                </div>

                <div className="flex justify-center md:justify-end">
                    <img
                        src={teamLogo}
                        alt="Đinh Thị Mỹ Diệp"
                        className="rounded-lg shadow-lg object-contain"
                    />
                </div>
            </div>
        </section>
    );
};

export default AboutHero;